module.exports = __webpack_public_path__ + "static/img/msp_title2.49db94f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/msp_title2.png
// module id = DIWQ
// module chunks = 0